import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Testimonials } from './components/Testimonials';
import { Credibility } from './components/Credibility';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { WhyNow } from './components/WhyNow';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { testimonialSlotsSerie1, testimonialSlotsSerie2 } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-creme font-sans text-graphite selection:bg-graphite selection:text-creme" data-id="element-0" data-mp="3iiwfuqnezm4a">
      <MetaPixel data-id="element-1" data-mp="3mjztr7lwj82v" />
      <main data-id="element-2" data-mp="3mjg93j4va5l5">
        <Hero data-id="element-3" data-mp="3rc9f0ac2njyt" />
        <ProofBar data-id="element-4" data-mp="3rcj31sdk3h1v" />
        <Testimonials id="temoignages-1" slots={testimonialSlotsSerie1} eyebrow="Témoignages" title="Ce que disent les coachs qui utilisent le système" note="Emplacements réservés. Aucun témoignage n’est publié avant d’être réel et accompagné d’un consentement écrit." tone="paper" data-id="element-5" data-mp="3rbzpsoyupgu6" />
        <Credibility data-id="element-6" data-mp="33oi2b5mmd4x0" />
        <PainGrid data-id="element-7" data-mp="38m1fe27kzbnd" />
        <BigIdea data-id="element-8" data-mp="38li6tc3tlzm0" />
        <ProductReveal data-id="element-9" data-mp="38l06a3a4kz8a" />
        <Tomes data-id="element-10" data-mp="38nuodo5o27yj" />
        <Bonuses data-id="element-11" data-mp="3dkuuu06fhcq6" />
        <WhyNow data-id="element-12" data-mp="3dle1gkqmoeow" />
        <Pricing data-id="element-13" data-mp="3dlw727z6k59h" />
        <Transformation data-id="element-14" data-mp="3dmfq5s0kgzp3" />
        <Testimonials id="temoignages-2" slots={testimonialSlotsSerie2} eyebrow="Témoignages" title="Des parcours menés jusqu’au bout" note="Emplacements réservés. Les citations nommeront les composants du système, sans être réécrites ni suggérées par nous." tone="paper" data-id="element-15" data-mp="3dirvgpjdy78s" />
        <Guarantee data-id="element-16" data-mp="3udknzzefn0bz" />
        <Faq data-id="element-17" data-mp="3ubzsa6gdtbcj" />
        <CostOfInaction data-id="element-18" data-mp="3uc9nq9k74apm" />
        <Close data-id="element-19" data-mp="3uf5gzkl3mb7q" />
      </main>
      <Footer data-id="element-20" data-mp="d57ep0qhqei0" />
    </div>;
}